export const setZohoSalesIq = () => {
  try {
    // eslint-disable-next-line
    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
      widgetcode: '4b48ff4c1474a74187d98868a4213894f0b90ee885052cf130bbd421bf74bb34',
      values: {},
      ready: () => {},
    };
    const d = document;
    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.id = 'zsiqscript';
    s.async = true;
    s.src = 'https://salesiq.zoho.com/widget';
    const t = d.getElementsByTagName('script')[0];
    t.parentNode.insertBefore(s, t);
    d.body.insertAdjacentHTML('beforeend', '<div id=\'zsiqwidget\'></div>');

    window.$zoho.salesiq.ready = () => {
      // https://www.zoho.com/salesiq/help/developer-section/js-api-chat-float-visibility.html
      window.$zoho.salesiq.floatbutton.visible('hide');
    };
  } catch (e) {
    console.log(e);
  }
};
